export default {
  general: {
    showFavourites: true,
    appResetTimeoutMinutes: 15,
    showSoldNeighbourhoods: false,
    showSoldReleases: false,
    showSoldSlides: false, 
  },

  filter: {
    enabled: false,
  },
};
